import { render, staticRenderFns } from "./ChoiceActorMail.vue?vue&type=template&id=1083bbf8&"
import script from "./ChoiceActorMail.vue?vue&type=script&lang=js&"
export * from "./ChoiceActorMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports